import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class TextTimer extends Phaser.GameObjects.Container {
  static get TIMER_DONE() {return 'TIMER_DONE';}

  constructor(scene, size, color) {
    super(scene);

    this.size = size;
    this.color = color;
    this.textLabel = null;
    this.totalSeconds = 0;
    this.ticker = null;
    this.tickerEnabled = true;
    this.startTime = 0;
    this.countDownFrom = 100;

    this.textLabel = this.scene.add.text(0, 0, '100', { fontFamily: FontKeys.odin, color, fontSize: `${size}pt`, align: 'center' }).setOrigin(.5, 0);
    this.add(this.textLabel);
  };

  start (number) {

    this.ticker = this.scene.time.addEvent({ delay: 1000, loop: true, callback: () => {this.handleTick();} , });

  }

  stop () {

    this.ticker.paused = true;

    this.tickerEnabled = false;
  }

  handleTick () {
    if (this.tickerEnabled && this.countDownFrom !== 0) {
      this.countDownFrom--;
      this.textLabel.text = this.countDownFrom;
    }
    else if (this.countDownFrom === 0) {
      this.emit(TextTimer.TIMER_DONE);
    }

  }

  getTime () {

    return this.textLabel.text;
  }

  getTimeLeft () {
    // should just return getTime
    return this.countDownFrom;

  }
}